import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getMerchCardsToShow } from '../../../constants/merchCards/MerchCardsToShow';
import { MobileSuiteTile } from './MobileSuiteTile';
import { borderStyle, StyledCardGrid } from '../../merch-card/MerchCardSharedComponents';
import { FREE } from 'self-service-api/constants/ProductLevels';
import MobileSuiteFreeTile from './MobileSuiteFreeTile';
import MobileProductLevelSelectorButtons from '../MobileProductLevelSelectorButtons';

const MobileSuiteTileContainer = ({
  selectedTab
}) => {
  const productLevelsToShow = getMerchCardsToShow({
    tab: selectedTab
  });
  const [selectedProductLevel, setSelectedProductLevel] = useState(productLevelsToShow[0]);
  useEffect(() => {
    if (!productLevelsToShow.includes(selectedProductLevel)) {
      setSelectedProductLevel(productLevelsToShow[0]);
    }
  }, [selectedTab, productLevelsToShow, selectedProductLevel]);
  const commonStyles = {
    paddingLeft: 28,
    paddingRight: 28,
    borderRight: borderStyle,
    borderLeft: borderStyle
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column align-center justify-center m-x-auto",
    style: {
      width: '100%'
    },
    children: [/*#__PURE__*/_jsx(MobileProductLevelSelectorButtons, {
      productLevels: productLevelsToShow,
      selectedProductLevel: selectedProductLevel,
      onClick: setSelectedProductLevel
    }), /*#__PURE__*/_jsx(StyledCardGrid, {
      columns: 1,
      children: selectedProductLevel === FREE ? /*#__PURE__*/_jsx(MobileSuiteFreeTile, {
        commonStyles: commonStyles
      }) : /*#__PURE__*/_jsx(MobileSuiteTile, {
        productLevel: selectedProductLevel,
        commonStyles: commonStyles
      })
    })]
  });
};

export default MobileSuiteTileContainer;